import { useConsumerWebhooks } from '@page/webhooks/webhooks.hook';

import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useLoadApplicationStatsQuery } from '@hook/stats/stats.hooks';
import { useStoreSelector } from '@hook/store/store.hooks';
import { isString } from '@util/data/is-exist';

export const useDashboardStats = () => {
  const { current } = useCurrentApplication();
  const stats = useLoadApplicationStatsQuery(current?.id, {
    skip: !isString(current?.id),
    refetchOnMountOrArgChange: true,
  });

  const { data: webhooks } = useConsumerWebhooks();

  const consumers = useStoreSelector((state) => Object.keys(state.consumers.data).length);

  return { ...stats.data, connections: 0, consumers, webhooks: webhooks.length };
};
